import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { State, process } from '@progress/kendo-data-query';
import { gridHeader, GridOptions } from '../../models/options';

@Component({
  selector: 'app-generic-grid',
  templateUrl: './generic-grid.component.html',
  styleUrls: ['./generic-grid.component.scss']
})
export class GenericGridComponent implements OnInit {

  showActionsDialog: boolean = false;

  public showGrid: boolean = false;
  public hasRows: boolean = false;

  options: GridOptions = {
    paging: true,
    perPage: 15,
    showToolbar: true,
    showSearchField: true,
    showExportExcelButton: true,
    showExportPDFButton: true,
    toolbarTitle: "",
    hideActionButtons: false,
    showEditButton: true,
    showDeleteButton: true,
    showDetailsButton: false,
    showActivateButton: false,
  };

  public columns: gridHeader[] = [];
  public items: any[] = [];
  public bindingType: String = 'array';
  public gridData: any;

  public gridDataResult: GridDataResult;

  public state: State;

  @Output() rowToEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowToDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowToSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCellClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowToActivate: EventEmitter<any> = new EventEmitter<any>();

  filters: any[] = [];

  defaultDate: Date = new Date("2000-01-01T00:00:00");

  selectedItem: any;

  constructor() { }

  ngOnInit(): void {
    
  }

  setData(data: any) {
    this.items = data;
  }

  loadGridData() {
    this.state = {
      skip: 0,
      take: this.options.perPage,
      filter: {
        logic: "or",
        filters: this.filters
      }
    };
    this.gridData = process(this.items, this.state);
  }

  setGridOptions() {
    this.loadGridData();
    this.showGrid = true;
  }

  select(row: any) {
    this.rowToSelect.emit(row);
  }

  edit(row: any) {
    this.rowToEdit.emit(row);
  }

  delete(row: any) {
    this.rowToDelete.emit(row);
  }

  activate(row: any) {
    this.rowToActivate.emit(row);
  }

  addRow(row: any) {
    this.items.push(row);
    this.loadGridData();
  }

  addRowAtTop(row: any) {
    this.items.unshift(row);
    this.loadGridData();
  }

  updateRowByUUID(row: any) {
    try {
      let last = this.items.find(item => item.UUID === row.UUID);
      let idx = this.items.indexOf(last);
      this.items[idx] = row;
      this.loadGridData();
    } catch (e) {
      alert(e);
    }
  }

  deleteRow(uuid: string) {
    let last = this.items.find(item => item.UUID === uuid);
    let idx = this.items.indexOf(last);
    this.items.splice(idx, 1);
    this.loadGridData();
  }

  public dataStateChange(state): void {
    this.state = state;
    this.gridData = process(this.items, this.state);
  }

  public onFilter(inputValue: string): void {
    this.state.filter = {
      logic: "or",
      filters: this.createFilters(inputValue)
    };
    this.gridData = process(this.items, this.state);
  }

  private createFilters(inputValue: string): any[] {
    this.filters = [];

    this.columns.forEach(item => {
      this.filters.push({
        field: item.field,
        operator: 'contains',
        value: inputValue,
      });
    });

    return this.filters;
  }

  public cellClickHandler({ isEdited, dataItem, rowIndex }): void {
    if (this.options.rowClick) {
      this.showActionsDialog = true;
      this.selectedItem = dataItem;
    } else {
      this.onCellClicked.emit(dataItem);
    }
  }

  dialogEditButton() {
    this.showActionsDialog = false;
    this.rowToEdit.emit(this.selectedItem);
  }

  dialogDeleteButton() {
    this.showActionsDialog = false;
    this.rowToDelete.emit(this.selectedItem);
  }

  dialogSelectButton() {
    this.showActionsDialog = false;
    this.rowToSelect.emit(this.selectedItem);
  }

}
